import {
  type AnalyticsEventProperties,
  resolveCanonicalEventName,
  normalizeAnalyticsProperties,
} from "@/lib/analytics/events";

export type NormalizedAnalyticsEvent = {
  name: string;
  canonicalName: string | null;
  properties: AnalyticsEventProperties;
};

export function createAnalyticsEvent(
  name: string,
  properties?: AnalyticsEventProperties,
): NormalizedAnalyticsEvent {
  const canonicalName = resolveCanonicalEventName(name);
  const normalizedProperties = normalizeAnalyticsProperties(properties);
  return {
    name,
    canonicalName,
    properties: canonicalName
      ? {
          ...normalizedProperties,
          canonical_event_name: canonicalName,
          ...(canonicalName !== name ? { legacy_event_name: name } : {}),
        }
      : normalizedProperties,
  };
}

export function shouldEmitCanonicalEvent(_name: string, _canonicalName: string | null) {
  void _name;
  void _canonicalName;
  return false;
}
